/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFlatten } from '../../factoriesAny.js';
export var flattenDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createFlatten: createFlatten
};